<template>
  <div class="layout">
    <div class="siderbar-wrapper" :class="{ 'siderbar-wrapper-collapsed': isCollapsed }">
      <el-menu text-color="#2F3030" active-text-color="#00B498" class="menu-wrapper" @open="test" router unique-opened
        :collapse="isCollapsed" :default-active="activeIndex"
        @select="selectMenu">
        <template v-for="(item, index) in visibleMenuData">
          <li v-if="item.jumpUrl == '@LINK'" class="el-menu-item menu-itemFix1" style="padding-left: 20px;">
            <p  @click="toLink(item)">
               <el-image  :src="item.iconUrl" alt="" class="imgSize img-default"></el-image>
                <el-image :src="item.onHoverIconUrl" alt="" class="imgSize  img-hover"></el-image>
                <span slot="title" class="menu-name">{{ item.name }}</span>
            </p>
          </li>
          <el-menu-item class="menu-itemFix1" v-else-if="item.jumpUrl !== '@LINK' && !item.children" :index="item.jumpUrl" :key="index">
            <p>
              <!-- <i :class="item.iconUrl"></i> -->              
              <el-image  :src="item.iconUrl" alt="" class="imgSize img-default"></el-image>
              <el-image :src="item.onHoverIconUrl" alt="" class="imgSize  img-hover"></el-image>
              <span slot="title" class="menu-name">{{ item.name }}</span>
            </p>
          </el-menu-item>
          <!-- <el-submenu v-else :index="item.jumpUrl" class="menu-itemFix2" @mouseenter.native="item.hover = true" @mouseleave.native="item.hover = false"> -->
            <el-submenu v-else :index="item.jumpUrl" class="menu-itemFix2">
            <template slot="title">
              <!-- <i class="submenu" :class="item.iconUrl"></i> -->
              <div class="menu_second">
                <!-- <el-image v-if="!item.isSelect && item.hover == false" :src="item.iconUrl" alt="" class="imgSize" style="margin-right: 6px;"></el-image>
                <el-image v-if="item.isSelect || (item.hover == true && !item.isSelect)" :src="item.onHoverIconUrl" alt="" class="imgSize" style="margin-right: 6px;"></el-image> -->
                <el-image :src="item.iconUrl" alt="" class="imgSize img-default" ></el-image>
                <el-image :src="item.onHoverIconUrl" alt="" class="imgSize img-hover"></el-image>
                <!-- <span style="position: relative" class="submenu" slot="title">
                  <span class="menu-name">
                    {{ item.name }}
                  </span>
                </span> -->
                <span class="menu-name">{{ item.name }}</span>
              </div>


            </template>
            <div v-for="(sub_item, sub_index) in item.children" :key="sub_index">
              <li v-if="sub_item.jumpUrl == '@LINK'" class="el-menu-item menu-item menu-itemFix is-active" >
                <p style="margin-left: 52px;" @click="toLink(sub_item)">
                  <span style="color: #2f3030;">{{ sub_item.name }}</span>
                </p>
              </li>
              <el-menu-item v-else class="menu-item menu-itemFix" 
                :index="sub_item.jumpUrl" @click="test(sub_item, item)">
                <p style="margin-left: 52px;">
                  <span >{{ sub_item.name }}</span>
                </p>
              </el-menu-item>
             </div>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div class="topbar-wrapper">
      <div class="topbar-wrapper-left">
        <img src="../../assets/title.png" style="width: 112px; height: 32px;" />
        <!-- <div class="line"></div>
        <div class="title">OA管理系统</div> -->
      </div>
      <div class="topbar-wrapper-right">
        <div class="btn">
          <div v-for="(item, index) in btns" :key="index"
            :class="[currentIndex == index ? 'btn_item_active' : 'btn_item']" @click="selectSystem(index)">
            {{ item.name }}
          </div>
        </div>
        <div class="name" v-if="!is_null(personInfo)">{{ personInfo.reallyName }}</div>
        <div class="company" v-if="!is_null(personInfo)">{{ personInfo.orgName }}</div>
        <div class="notice" @click="$router.push('/notice')" style="cursor: pointer">
          <img src="../../assets/img/notice/icon_tongzhi_16.png" alt="">
          通知
          <el-tag font-size="18px" round v-if="readCount.unread !=='undefined' ">
            <p>{{ readCount.unread}}</p>
          </el-tag>
        </div>
        <div class="setting">
          <el-dropdown @command="command($event)">
            <div style="display: flex;justify-content: center;align-items: center;cursor: pointer;">
              <i class="el-icon-setting"></i>
              <div class="setting-t">设置</div>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item class="custom-item" command="password">修改登录密码</el-dropdown-item>
              <el-dropdown-item class="custom-item" command="info">个人信息</el-dropdown-item>
              <el-dropdown-item class="custom-item" command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <i class="el-icon-setting"></i>
          <div class="setting-t">设置</div> -->
        </div>
      </div>

      <!-- 导航栏	 -->
    <div class="nav" :style="{ left: this.isCollapsed ? '96px' : '216px' }">
      <!-- <i class="el-icon-adm-home iconHome" @click="tohome"></i> -->
      <tarbar></tarbar>
    </div>
    </div>
    <div @click="toggleMenu" class="toggle-menu" :class="{'toggle-menu-collapsed':isCollapsed}"></div>
    <div class="content-wrapper" ref="content-wrapper" :style="{ left: this.isCollapsed ? '80px' : '200px',bottom:hasBottom?'84px':'0' }"  @scroll="handleScroll">
      <div class="content">
        <transition name="slide-fade">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.name" :pageActive="pageActive"></router-view>
          </keep-alive>
        </transition>
        <transition name="slide-fade">
          <router-view v-if="!$route.meta.keepAlive" :key="$route.name" :pageActive="pageActive"></router-view>
        </transition>
      </div>
    </div>
    <!--确认 -->
    <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
      <div style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">
        是否确认退出当前账号登录？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isConfirm = false">取 消</el-button>
        <el-button type="primary" @click="logout">确认</el-button>
      </span>
    </el-dialog>
    <!--备注 -->
    <el-dialog title="修改密码" :visible.sync="isPassword" width="552px" append-to-body>
      <div class="dialog-body">
        <div class="dialog-title">
          <el-form :inline="true" :model="form" ref="form" class="form" size="small" style="width:100%" :rules="rules">
            <el-form-item label="输入旧密码" style="margin-left: 20px;" prop="oldPassword">
              <el-input v-model="form.oldPassword" placeholder="请输入" maxlength="16" show-word-limit
                style="width: 346px;"></el-input>
            </el-form-item>
            <el-form-item label="输入新密码" style="margin-left: 20px;" prop="newPassword">
              <el-input v-model="form.newPassword" placeholder="请输入" maxlength="16" show-word-limit
                style="width: 346px;"></el-input>
            </el-form-item>
            <el-form-item label="重复新密码" style="margin-left: 20px;" prop="secondNewPassword">
              <el-input v-model="form.secondNewPassword" placeholder="请输入" maxlength="16" show-word-limit
                style="width: 346px;"></el-input>
            </el-form-item>
          </el-form>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isPassword = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { sessionStorage } from '@/assets/js/storage'
import { mapGetters } from 'vuex'
import { auditRequest } from '@/api/chatAudit'
import { driveRequest } from '@/api/personalDrive'
import { chatManagementMenus } from '@/utils/chat-management-menu'
// import mixinsCommon from '@/mixins/common'
// 监听页面滚动的路由名称
const wathchPage = ['info','addApplication','addSatff']
const hasBottomPage = ['info','addApplication','addSatff','sendApproval','approvalMyDetail','approvalManageDetail','approvalCCDetail','approvalAllDetail']
export default {
  // mixins: [mixinsCommon],
  name: 'layout',
  data() {
    return {
      activeIndex: null,
      chatManagementAllowed: false,
      chatAccessVersion: 0,
      driveManagementAllowed: false,
      driveAccessVersion: 0,
      isPassword: false,
      isConfirm: false,
      currentIndex: 1,
      btns: [
        {
          name: '五域'
        },
        {
          name: '航讯通'
        }
      ],
      activeName: '2',
      upRead: [],
      readT: [],
      // readCount:{}, // 通知数量
      dialogVisible: false,
      titleCopy: '',
      imghttp: this.ImgHttps,
      sider_menu_data: sessionStorage.getItem('limit')
        ? sessionStorage.getItem('limit').menuTreeList
        : [],
      adminMenuShow: false,
      levelList: null,
      personInfo: sessionStorage.getItem('personInfo'),
      errorCount: 0,
      orderLoading: false,
      form: {
        oldPassword: '',
        newPassword: '',
        secondNewPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        secondNewPassword: [
          { required: true, message: '请输入再次输入密码', trigger: 'blur' },
        ]
      },
       pageActive: '0', //锚点按钮
    }
  },
  created() {
    this.refreshChatManagementAccess()
    this.refreshDriveManagementAccess()
    // console.log(this.ImgHttps)
    this.getReadMessageByType(0)
    // this.wsConnection()
    this.checkAuth()
    this.getreadCount()  // 读取消息数量
    this.getBreadcrumb()
    if (!this.is_null(sessionStorage.getItem('limit'))) {
      sessionStorage.getItem('limit').menuTreeList.forEach(item => {
        item.hover = false
        item.isSelect = false
        if (item.children) {
          item.children.forEach(itm => {
            itm.hover = false
          })
        }
      })
      this.sider_menu_data = sessionStorage.getItem('limit').menuTreeList
      // console.log(this.sider_menu_data)
    }
    this.sider_menu_data.forEach((res) => {
      res.oneIsClick = false
      res.hover = false
      res.isSelect = false
      if (res.children) {
        res.children.forEach((r) => {
          r.twoIsClick = false
          r.hover = false
        })
      }
    })


    // console.log(this.activeIndex)
    this.initMenu()
    this.addLimit()
  },
  computed: {
    visibleMenuData() {
      return chatManagementMenus(this.sider_menu_data, this.chatManagementAllowed, this.driveManagementAllowed)
    },
    user() {
      return this.$store.state.user_id
    },
    cachedViews() {
      return this.$store.state.cacheView
    },
    isCollapsed() {
      return this.$store.state.isCollapsed
    },
    key() {
      return this.$route.path
    },
    hasBottom() {
      return hasBottomPage.includes(this.$route.name)
    },
    ...mapGetters(['readCount']), //自动响应式更新
  },
  beforeDestroy() {
    this.chatAccessVersion++
    this.driveAccessVersion++
  },
  mounted() {
    
    if (!this.is_null(sessionStorage.getItem('limit'))) {
      sessionStorage.getItem('limit').menuTreeList.forEach(item => {
        item.hover = false
        item.isSelect = false
        if (item.children) {
          item.children.forEach(itm => {
            itm.hover = false
          })
        }
      })
      this.sider_menu_data = sessionStorage.getItem('limit').menuTreeList
      // console.log(this.sider_menu_data)
    }
  },
  watch: {
    $route(to,form) {
      this.refreshChatManagementAccess()
      this.refreshDriveManagementAccess()
      const q = this.$route.query
      this.titleCopy = ''
      if (q.jage == 1) {
        this.titleCopy = '申请被退货'
      } else if (q.exType == 1 && q.orderType == 0) {
        this.titleCopy = '拒收详情'
      } else if (q.exType == 1 && q.orderType == 1) {
        this.titleCopy = '被退货详情'
      } else if (q.exType == 0) {
        this.titleCopy = '退货详情'
      }
      this.getBreadcrumb()
      this.initMenu()
      this.getreadCount()  // 读取消息数量
      // console.log('watch>>',to)
      if (wathchPage.includes(to.name)){
        this.$refs['content-wrapper'].scrollTop = 0;
        this.pageActive = '0'
      }
      
    }
  },
  methods: {
    async refreshChatManagementAccess() {
      const version = ++this.chatAccessVersion
      this.chatManagementAllowed = false
      try {
        const result = await auditRequest('/context')
        if (version === this.chatAccessVersion) this.chatManagementAllowed = result.canView === true
      } catch (_) { /* 未授权、超时和网络错误均保持隐藏，接口另行执行实时授权检查。 */ }
    },
    async refreshDriveManagementAccess() {
      const version = ++this.driveAccessVersion
      this.driveManagementAllowed = false
      try {
        const result = await driveRequest('/admin/context')
        if (version === this.driveAccessVersion) this.driveManagementAllowed = result.canManage === true
      } catch (_) { /* 仅专用文件管理角色可见；通配管理员、超时和网络错误都保持隐藏。 */ }
    },
    initMenu(){
      if (localStorage.getItem('selectedMenuIndex')) {
        this.activeIndex = localStorage.getItem('selectedMenuIndex')
      } else {
        if (this.sider_menu_data[0].children) {
          this.activeIndex = this.sider_menu_data[0].children[0].jumpUrl
        } else {
          this.activeIndex = this.sider_menu_data[0].jumpUrl
        }

      }
      let childIndex = -1
      let code = ''
      this.sider_menu_data.forEach((item, inx) => {
      if (item.jumpUrl == this.activeIndex) {
        this.sider_menu_data[inx].isSelect = true
      } else {
        this.sider_menu_data[inx].isSelect = false

      }
      if (item.children) {
        // console.log(item.children, '=====')
        childIndex = item.children.findIndex(itm => itm.jumpUrl == this.activeIndex)
        if (childIndex != -1) {
          code = item.children[childIndex].parentCode
          if (item.code == code) {
            this.sider_menu_data[inx].isSelect = true
          } else {
            this.sider_menu_data[inx].isSelect = false
          }
        }

      }

      })
    },
    selectSystem(index) {
      // this.currentIndex = index
      if (index == 0) {
        let url = process.env.VUE_APP_API_BASE_URL_LINK1 + '/#/center?token='
        let token = sessionStorage.getItem('token')
        window.open(url + token);
      }
    },
    selectMenu(index) {
      // console.log(index)
      let childIndex = -1
      let code = ''
      this.sider_menu_data.forEach((item, inx) => {
        if (item.jumpUrl == index) {
          this.sider_menu_data[inx].isSelect = true
        } else {
          this.sider_menu_data[inx].isSelect = false

        }
        if (item.children) {
          // console.log(item.children, '=====')
          childIndex = item.children.findIndex(itm => itm.jumpUrl == index)
          if (childIndex != -1) {
            code = item.children[childIndex].parentCode
            if (item.code == code) {
              this.sider_menu_data[inx].isSelect = true
            } else {
              this.sider_menu_data[inx].isSelect = false
            }
          }

        }

      })
      localStorage.setItem('selectedMenuIndex', index)
    },
    command(val) {
      // console.log(val)
      if (val == 'password') {
        this.isPassword = true
        this.$nextTick(() => { 
          this.$refs.form.resetFields()
        })
      } else if (val == 'info') {
        this.$router.push({ path: '/info' })
      } else if (val == 'logout') {
        this.isConfirm = true

      }

    },
    submitPassword() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios.put('/oa/sys/user/password', this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('修改成功')
              this.isPassword = false
              this.$router.push({ path: '/login' })

            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    setCookie(c_name, c_pwd, c_ckd, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        'userName' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'password' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'checked' + '=' + c_ckd + ';path=/;expires=' + exdate.toGMTString()
    },
    logout() {
      this.axios.get('/auth/token/logout').then((res) => {
        if (res.code == 0) {
          this.isConfirm = false
          this.$store.commit("clearCacheAll");
          sessionStorage.clear()
          localStorage.clear()
          this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
          this.$router.push({
            name: 'login',
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    toHelp() {
      window.open("https://docs.qq.com/doc/DVXJ2SGdHZWdtSnBQ")
    },
    // 同步订单
    syncOrder(row) {
      this.orderLoading = true
      const params = {
        id: row.id,
        userId: sessionStorage.getItem('user_id'),
        orderNo: row.messageObj.orderNo,
        platformType: row.messageObj.platformType,
        orderStatus: '1'
      }
      this.$api.orderMessage(params).then((res) => {
        if (res.code == 0) {
          this.orderLoading = false
          this.$message.success('更新完成')
          this.getReadMessageByType()
        } else {
          this.orderLoading = false
        }
      })
        .catch((err) => {
          console.log(err)
          this.orderLoading = false
        })
      // this.axios
      //   .get(
      //     '/order/message/websocket/handle/syncOrder?userId=' +
      //       sessionStorage.getItem('user_id') + '&id=' + row.id + '&orderNo=' + row.messageObj.orderNo + '&platformType=' + row.messageObj.platformType + '&orderStatus=1'
      //   )
      //   .then((res) => {
      //     if (res.code == 0) {
      //       this.orderLoading = false
      //       this.$message.success('更新完成')
      //     }
      //   })
    },
    getKeyByValue(e) {
      if (e == '我的订单') {
        return this.$store.getters.orderCount.orderTask
      } else if (e == '异常订单') {
        return this.$store.getters.orderCount.sum
      } else if (e == '健驰客户导入') {
        return this.$store.getters.orderCount.wechatUnassignedNum
      }
    },
    addLimit() {
      const temp = sessionStorage.getItem('limit')
      temp.menuTreeList = this.sider_menu_data
      sessionStorage.setItem('limit', temp)
    },
    test(e, item) {
      // console.log(e, '---')
      if (e.twoIsClick != undefined) {
        this.$set(
          item.children.find((res) => res.jumpUrl == e.jumpUrl),
          'twoIsClick',
          true
        )
      } else {
        this.$set(
          this.sider_menu_data.find((res) => res.jumpUrl == e),
          'oneIsClick',
          true
        )
      }
      this.addLimit()
    },
    handleClick(e) {
      // console.log(e.name)
      if (e.name == 1) {
        this.getReadMessageByType(1)
      }
    },
    // 我的通知未读消息统计
    getreadCount() {
      const params = {
        message: '', //消息标题
          type: '', //消息类型 1 审批单 2 公告 3 资产管理 4 考勤 5 系统提示
          status: '',//消息状态 1 未读 2 已读
          startTime: '', //开始时间
          endTime: '', //结束时间
          pageNo: 1,
          pageSize: 10,         
      }
      this.axios.post('/oa/notice/readCount',params).then((res) => {
        if (res.code == 0) {
          // this.readCount = res.data
          this.$store.commit("updateReadCount",   res.data);
          this.$forceUpdate(); //强制更新视图
          
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getReadMessageByType(e) {
      if (e) {
        this.axios
          .get(
            '/order/message/websocket/handle/readList?userId=' +
            sessionStorage.getItem('user_id')
          )
          .then((res) => {
            // console.log(res, 'rersfdfdsf')
            if (res.data) {
              res.data.forEach((item) => {
                item.totalQuantity = 0
                item.totalPrice = 0
                item.updateState = true
                if (item.messageObj && item.messageObj.goodsList) {
                  item.messageObj.goodsList.forEach((itemTwo) => {
                    if (itemTwo.updated == false) {
                      item.updateState = false
                    }
                    item.totalQuantity = item.totalQuantity + itemTwo.quantity
                    item.totalPrice = item.totalPrice + itemTwo.price
                  })
                }
              })
            }

            this.readT = res.data
          })
      } else {
        this.axios
          .get(
            '/order/message/websocket/handle/upReadList?userId=' +
            sessionStorage.getItem('user_id')
          )
          .then((res) => {
            // console.log(res, 'res')
            if (res.data) {
              res.data.forEach((item) => {
                item.totalQuantity = 0
                item.totalPrice = 0
                item.updatedNum = 0
                item.notUpdated = 0
                if (item.messageObj && item.messageObj.goodsList) {
                  item.messageObj.goodsList.forEach((itemTwo) => {
                    if (itemTwo.updated == true) {
                      item.updatedNum = item.updatedNum + 1
                    } else {
                      item.notUpdated = item.notUpdated + 1
                    }
                    item.totalQuantity = item.totalQuantity + itemTwo.quantity
                    item.totalPrice = item.totalPrice + itemTwo.price
                  })
                }
              })
            }

            // res.data.messageObj.goodsList.forEach((item) => {
            //   item.totalQuantity += item.quantity
            //   item.price += item.price
            // })
            this.upRead = res.data
            // console.log(this.upRead, 'this.upRead')
          })
      }
    },
    allRead() {
      this.axios
        .get(
          '/order/message/websocket/handle/oneKeyRead?userId=' +
          sessionStorage.getItem('user_id')
        )
        .then((res) => {
          this.getReadMessageByType(0)
        })
    },
    read(e) {
      this.axios
        .get(
          '/order/message/websocket/handle/read?id=' +
          e +
          '&userId=' +
          sessionStorage.getItem('user_id')
        )
        .then((res) => {
          this.getReadMessageByType(0)
        })
    },
    wsConnection() {
      const baseURL = process.env.VUE_APP_API_BASE_URL
      let wsURL = ''
      if (baseURL.indexOf('http://') > -1) {
        wsURL = baseURL.replace('http://', 'wss://')
      } else {
        wsURL = baseURL.replace('https://', 'wss://')
      }
      // console.log(wsURL)
      const userId = sessionStorage.getItem('user_id')
      this.ws = new WebSocket(`${wsURL}/order/websocket/${userId}`)
      this.ws.onopen = () => {
        // console.log("id为" + sessionStorage.getItem("user_id") + "连接成功");
      }
      this.ws.onmessage = (res) => {
        /*
        const temp = JSON.parse(res.data)
        this.$notify({
          title: '自定义位置',
          message: temp.message,
          position: 'bottom-right'
        })
        document
          .getElementsByClassName('el-badge')[0]
          .setAttribute('class', 'el-badge item')
        setTimeout(() => {
          document
            .getElementsByClassName('el-badge')[0]
            .setAttribute('class', 'el-badge')
        }, 1000)
        */
      }
      this.ws.onclose = (res) => {
        // console.log(res);
      }
    },
    tohome() {
      this.$router.push('/home')
      // // 区分登陆某个系统显示的首页
      // if (sessionStorage.getItem('userInfo').winType != '1') {
      //   this.$router.push('/dashboard')
      // } else {
      //   if (sessionStorage.getItem('personInfo').orgName != '物流部') {
      //     this.$router.push('/home')
      //   } else {
      //     this.$router.push('/logisticsIndex')
      //   }
      // }
    },
    getBreadcrumb() {
      const matched = this.$route.matched.filter((item) => item.name)
      // const first = matched[0];
      this.levelList = matched
      // console.log(this.levelList)
      const componentName = matched[matched.length - 1].name
      const detail = this.$route.path
      const fullPath = this.$route.fullPath

      // 当前路由匹配到name
      const name = matched[matched.length - 1].meta.title
      console.log('componentName:',componentName)
      this.$store.dispatch('commitToolBar', { name, detail, componentName ,fullPath})
    },
    checkAuth() {
      const token = this.$store.state.token || sessionStorage.getItem('token')
      // console.log(token+"-------token--layout")
      if (!token) {
        this.$router.replace('/login')
      } else {
        this.getUser()
      }
    },
    getUser() {
      // console.log('超级管理员');
    },
    is_null(content) {
      if (content) {
        return false
      } else {
        return true
      }
    },
    // handleCommand(command) {
    // 	console.log(command);
    // },
    toggleMenu() {
      this.$store.commit('updateCollapsed', !this.isCollapsed)
      // this.isCollapsed = !this.isCollapsed
    },
    exit() {
      this.$confirm('即将退出系统登录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios.get('/auth/token/logout').then((res) => {
            if (res.code == 0) {
              this.$store.commit('token', '')
              this.$store.commit('user_id', null)
              sessionStorage.clear()
              this.$router.push({
                name: 'login',
                query: {
                  type: 1
                }
              })
            } else {
              this.$message.error(res.message)
            }
          })
          this.$store.commit('closeTar')
        })
        .catch(() => {
          return false
        })
    },
    toPersonal() {
      this.$router.replace({
        path: '/personalinfo'
      })
    },
    handleScroll(i) {
      // console.log(this.$route.name)
      
      if (wathchPage.includes(this.$route.name)){
        // console.log('>>',i)
        // 获取所有锚点元素
        const app = document.getElementById('app');
        const navContents = app.querySelectorAll('.anchor-item');
        // const navContents = document.querySelectorAll('.anchor-item')
        // 所有锚点元素的 offsetTop
        const offsetTopArr = []
        navContents.forEach((item) => {
            offsetTopArr.push(item.offsetTop)
        })
        console.log(offsetTopArr)
        // 获取当前文档流的 scrollTop
        const scrollTop = this.$refs['content-wrapper'].scrollTop + 20
        offsetTopArr.forEach((item, index) => {
            if (scrollTop >= item) {
                this.pageActive = String(index)
            }
        })
        console.log('>>',this.pageActive)
      }
    },
    toLink(item){
      console.log('外链：',item)
      if(item.code == 'yanxue'){
        let userInfo = sessionStorage.getItem('userInfo')
        let phone = userInfo.phoneNumber
        window.open('/yanxue.html?phone='+phone, '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_tokens.scss";

/deep/.el-menu-item:focus {

  background-color: white !important;
}

/deep/.el-submenu__title:hover {
  background: transparent !important;
  color: #fff !important;
}



.siderbar-wrapper::-webkit-scrollbar {
  display: none;
}

/* 可以设置不同的进入和离开动画 */
.slide-fade-enter-active {
  transition: all 0.3s linear;
}

.slide-fade-leave-active {
  // transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  transition: all 0s linear;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translateX(-20px);
  opacity: 0;
}

/* 可以设置不同的进入和离开动画 */

/deep/.el-badge__content {
  position: absolute;
  top: 0;
}

/deep/.el-table td,
.el-table th {
  text-align: center;
}

/deep/ .el-table th>.cell {
  text-align: center;
  font-size: 16px;
}

/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}

/deep/.el-badge {
  margin-top: 10px;
  margin-right: 20px;
}

/deep/.el-badge__content {
  height: 12px;
  line-height: 12px;
  top: 5px;
}

.siderbar-wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.siderbar-wrapper {
  overflow: -moz-scrollbars-none;
}

.item {
  animation-name: mymove;
  /*动画的名称*/
  transform-origin: center bottom;
  /*设置动画旋转元素的基点为*/
  cursor: pointer;
}

.item {
  animation-duration: 1s;
  /*动画时间*/
  animation-fill-mode: both;
  /*播放后的状态*/
}

.item {
  animation-duration: 1s;
  /*动画时间*/
}

@keyframes mymove {

  0%,
  100%,
  20%,
  50%,
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.5, 0.855, 0.06);
    transform: translate3d(-20px, 0, 0);
  }
}

.siderbar-wrapper {
  position: fixed;
  top: 65px;
  bottom: 0;
  left: 0;
  width: $siderbarWidth;
  height: calc(100vh - 65px);
  z-index: 999;
  background-color:#FFF;
  transition: all 0.3s ease-in-out;
  overflow-y: auto;

  .logo-wrapper {
    padding: 16px 0;
    text-align: center;
    font-size: 24px;
    color: #ffffff;

    img {
      width: 95px;
      height: 77px;
    }
  }

  .menu-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-right: none;
    transition: all ease-in-out;
    padding-top: 16px;
    box-sizing: border-box;
    // &:not(.el-menu--collapse) {
    //   scrollbar-width: none;
    // }

    // &:not(.el-menu--collapse) i {
    //   color: #ffffff;
    // }

    // .el-submenu__title {
    //   // padding: 0px 15px;
    // }

    // .el-submenu,
    // .el-menu-item {
    //   width: 100%;
    // }
  }
}
// 收起侧边样式
.siderbar-wrapper-collapsed{
  width: 80px;
  /deep/ .el-submenu__title{
      padding: 0px!important;
      line-height: 1;
    }
  .menu-wrapper{
    .el-menu-item,
    .el-submenu{
        height: 64px;
        line-height: 1;
        padding:12px 0 0 0!important;
        text-align: center;
        margin:0 0 16px 0;
       box-sizing: border-box;
        .imgSize{
          margin: 0 auto 7px;
        }
        .menu-name{
          font-size: 12px;
          height: initial;
          width: inherit;
          overflow: initial;
          visibility: inherit;
          display: block;
          line-height: 1;
        }
      }
  }
}
.toggle-menu{
  position: absolute;
  top: 100px;
  left: 180px;
  z-index: 999;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: url("~@/assets/icon_shouqi_40px.png");
  background-size: 40px 40px;
  
}
.toggle-menu-collapsed{ 
  left: 60px;
   background-image: url("~@/assets/icon_shouqi_40px1.png");
   transition: left .3s ease-in-out;
}

.submenu {
  padding: 0 !important;
  // padding-left: 6px !important;
}

.el-icon-adm-exit {
  color: #2d7edf !important;
  font-size: 20px !important;
}

.menu-item-title {
  display: inline-block;
  vertical-align: middle;
  margin-right: 12px;

  span {
    display: inline-block;
    vertical-align: middle;
    color: #000;
    font-size: 15px;
  }

  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;
    margin: 0 10px;
  }
}

.menu-itemFix {
  padding: 0px !important;
  // margin: 15px 0;
  height: 48px !important;
  line-height: 48px !important;

  &:hover {
    background-color: #E4F7F4 !important;
  }
}

.menu-itemFix1 {
  padding: 0 0 0 24px;
  // margin: 15px 0;
  // height: 56px !important;
  // line-height: 56px !important;
  transition: all .3s ease;
  .imgSize{
    margin:0 8px 0 4px;
  }
  &:hover {
    background-color: #00B498 !important;
    color: #fff !important;
    .img-default{
      display: none;
    }
    .img-hover{
      display:inline-block;
    }
  }

  &.is-active {
    background-color: #00B498 !important;
    color: #fff !important;
    .img-default{
      display: none;
    }
    .img-hover{
      display:inline-block;
    }
  }
}

.menu-itemFix2 {
  transition: all .3s ease;
  .imgSize{
    margin:0 8px 0 4px;
  }
  &:hover {
    background-color: #00B498 !important;
    color: #fff !important;
    .img-default{
      display: none;
    }
    .img-hover{
      display:inline-block;
    }
    /deep/ .el-submenu__title {
      color: white !important;
    }

    /deep/ .el-submenu__title i {
      color: white;
      font-size: 16px;
      margin-top: -6px !important;
    }
  }
  &.is-active {
    background-color: #00B498 !important;
    color: #fff !important;
    .img-default{
      display: none;
    }
    .img-hover{
      display:inline-block;
    }
    /deep/ .el-submenu__title {
      color: white !important;
    }

    /deep/ .el-submenu__title i {
      color: white;
      font-size: 16px;
      margin-top: -6px !important;
    }
  }
}

.elStyle {
  height: 30px;
  line-height: 30px !important;
  padding-left: 30px !important;

  // width: 80%;
  // border:1px solid #000;
  .imgSize {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }

  i {
    display: inline-block;
    vertical-align: middle;
    color: #000
  }

  span {
    display: inline-block;
    vertical-align: middle;
    height: 18px;
    line-height: 22px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.2) !important;
    // color: #2d7edf !important;

    i {
      color: #2d7edf !important;
    }
  }
}

/deep/ .el-submenu__title i {
  color: #2f3030;
  font-size: 16px;
  margin-top: -6px !important;
}


// /deep/.el-menu-item i {
//   color: #fff;
// }

.nav {
  position: fixed;
  left: $siderbarWidth;
  right: 0;
  overflow: hidden;
  // width:100%;
  top: 65px;
  height: 40px;
  line-height: 40px;
  padding: 0px;
  background-color: #F5FAF9;
  // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease-in-out;
  padding: 12px 16px 0 0;
  z-index: 12;
  // border-top: 1px solid #f8f8f8;

  p {
    display: inline-block;
    font-size: 13px;
    padding: 0px 8px;
    margin-right: 8px;
  }

  .iconHome {
    font-size: 18px;
    position: absolute;
    top: 6px;
    left: 30px;
    color: #137dff;
    width: 20px;
    height: 20px;
    background-color: red;
  }
}

.topbar-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 64px;
  line-height: 64px;
  padding-left: 24px;
  padding-right: 24px;
  background-color: $topbarBackgroundColor;
  box-shadow: 0px 0.5px 0px 0.5px #EDF2F2;
  // border-radius: 0px 0px 16px 16px;
  z-index: 12;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .topbar-wrapper-left {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .line {
      width: 2px;
      height: 24px;
      background: #EDF2F2;
      border-radius: 0px 0px 0px 0px;
      margin-left: 18px;
      margin-right: 12px;
    }

    .title {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 24px;
      color: #2F3030;
    }
  }

  .topbar-wrapper-right {
    display: flex;
    justify-content: space-between;

    .btn {
      width: 112px;
      height: 32px;
      background: #FFF;
      border-radius: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      margin-top: 16px;
      border: 1px solid #00B498;
      box-sizing: border-box;
      .btn_item {
        width: 42px;
        height: 30px;
        background: #FFF;
        border-radius: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #00B498;
        line-height: 30px;
        text-align: center;

      }

      .btn_item_active {
        width: 70px;
        height: 30px;
        background: #00B498;
        border-radius: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 30px;
        text-align: center;
      }
    }

    .name {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2F3030;
      margin-left: 26px;
    }

    .company {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2F3030;
      margin-left: 16px;
    }

    .notice {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2F3030;
      margin-left: 24px;
      display: flex;
      align-items: center;
      position: relative;

      /deep/.el-tag {
        border: none;
        padding: 0;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        line-height: 18px;
        border-radius: 50%;
        background-color: #E23C58;
        top: -12px;
        left: -4px;
        position: relative;

        p {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: bold;
          font-size: 12px;
          color: #FFFFFF;
        }

      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }

    .setting {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 25px;

      .setting-t {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2F3030;
        margin-left: 4px;
      }
    }
  }

  .menu-collapse-wrapper {
    height: 100%;
    width: 38px;
    text-align: center;
    cursor: pointer;

    i {
      transition: all 0.3s ease-in-out;
    }
  }

  .title {
    height: 100%;
    font-weight: bold;
  }

  .menu-list {

    // width:290px;
    .menu-item {
      position: relative;
      // float: left;
      min-width: 45px;
      text-align: center;

      &:hover {
        cursor: pointer;
        background-color: #fff;
      }

      .icon {
        vertical-align: middle;
        font-size: 24px;
      }

      .text {
        display: inline-block;
        vertical-align: middle;
        margin-left: 4px;
        font-size: 16px;
      }
    }
  }
}

.content-wrapper {
  position: fixed;
  left: $siderbarWidth;
  right: 0;
  // top: $topbarHeight;
   top:116px;
  bottom: 0;
  padding: 0 16px 0 16px;
  overflow: auto;
  transition: all 0.3s ease-in-out;
  // background-color: white;

  .content {
    position: relative;
    width: 100%;
    height: 100%;
    /deep/ .content{
      margin-top: 0!important;
    }
  }
}

// /deep/.el-submenu__icon-arrow {
//   margin-top: -4px !important;
// }

// /deep/.el-image__inner {
//   vertical-align: middle;
// }

.siderbar-wrapper .menu-wrapper:not(.el-menu--collapse) {
  overflow-y: initial;
  overflow-x: initial;
}
.imgSize {
  width: 20px;
  height: 20px;
}
.img-hover{
  display: none;
}
</style>
